import React from 'react';
import { withNamespaces, Trans } from 'react-i18next';
import styled from 'styled-components';
import Button from 'components/Button';
import Icon from 'components/Icon';
import Paragraph from 'components/Paragraph';
import { Divider } from 'apps/rfq/rfqPage/views/openRFQ.styled';
import {
  ContentWrapper,
  CollapseWrapper,
  LargePanelSectionWrapper,
} from 'apps/rfq/rfqForm/views/onboarding.styled';
import PropTypes from 'prop-types';
import { analytics } from 'core/analytics';
import { observer } from 'mobx-react';

const NeedPerfectQuote = observer(props => {
  const { rfqManager, isCustomer } = props;
  const { someQuestionsAnswered } = rfqManager;

  if (!isCustomer && !someQuestionsAnswered) return null;

  return (
    <>
      <LargePanelSectionWrapper first>
        <CollapseWrapper>
          <ContentWrapper>
            <TwoRowTwoColumnDiv>
              <div style={{ display: 'flex' }}>
                {isCustomer && !someQuestionsAnswered && (
                  <Icon
                    name='info'
                    color='#0f2eff'
                    style={{
                      transform: 'translateY(4px)',
                      marginRight: '7px',
                      display: 'inline',
                    }}
                  />
                )}
                {((isCustomer && someQuestionsAnswered) || !isCustomer) && (
                  <Icon
                    name='check'
                    color='#0f2eff'
                    style={{
                      transform: 'translateY(4px)',
                      marginRight: '7px',
                      display: 'inline',
                    }}
                  />
                )}
                {isCustomer ? (
                  <Paragraph style={{ fontWeight: 'bold' }} variant='tertiary'>
                    <Trans>
                      {' '}
                      {someQuestionsAnswered
                        ? 'Additional Quoting Info sent.'
                        : 'Need the perfect quote?'}
                    </Trans>
                  </Paragraph>
                ) : (
                  <Paragraph style={{ fontWeight: 'bold' }}>
                    <Trans>Customer&apos;s Quoting Priorities.</Trans>
                  </Paragraph>
                )}
              </div>
              <div></div>
              <Paragraph margin='0 0 0 1.4rem' variant='tertiary'>
                {isCustomer && someQuestionsAnswered && (
                  <Trans>
                    Thanks for submitting additional information about your
                    quote. This helps us get you the best possible fit.
                  </Trans>
                )}
                {isCustomer && !someQuestionsAnswered && (
                  <Trans>
                    Tell our manufacturers more about your requirements and
                    priorities to get the best possible quote.
                  </Trans>
                )}
                {!isCustomer && (
                  <Trans>
                    Please review the customer&apos;s additional quoting
                    requirements, to provide the best possible quote.
                  </Trans>
                )}
              </Paragraph>
              <Paragraph style={{ margin: 'auto' }}>
                <Button
                  icon='info'
                  iconPosition='right'
                  text={
                    rfqManager.someQuestionsAnswered
                      ? 'Review info'
                      : 'Tell us more'
                  }
                  outline={!!rfqManager.someQuestionsAnswered}
                  variant='tertiary'
                  onClick={() => {
                    analytics.sendEvent(
                      'rfq-qualification-form-click-more',
                      {},
                      { ga: true },
                    );
                    rfqManager.showQualityForm();
                  }}
                  style={{ margin: '0 auto' }}
                />
              </Paragraph>
            </TwoRowTwoColumnDiv>
          </ContentWrapper>
        </CollapseWrapper>
        <Divider />
      </LargePanelSectionWrapper>
    </>
  );
});

const TwoRowTwoColumnDiv = styled.section`
  display: grid;
  grid-template-columns: 2.5fr 1.5fr;
  grid-template-rows: 0.2fr 0.8fr;
  grid-row-gap: 0.75rem;
`;

export default withNamespaces()(NeedPerfectQuote);

NeedPerfectQuote.propTypes = {
  rfqManager: PropTypes.object,
  isCustomer: PropTypes.bool,
};
